/* Raine & Co theme core: header, drawers, bag (Shopify cart), wishlist, search, rails, reveal, cookie banner.
   Exposes window.RC (see NOTES-core.md). Ported from the approved concept room app.js. */
(function () {
  'use strict';
  var D = document, W = window;
  var CFG = W.RC_CFG || {};
  var ROUTES = CFG.routes || {};
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  var NB = ' ';

  /* ---------- helpers ---------- */
  function fmt(cents) { var n = Math.round((Number(cents) || 0) / 100); return 'R' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, NB); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var mem = {};
  function sget(k, d) { try { var v = W.localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return mem[k] !== undefined ? mem[k] : d; } }
  function sset(k, v) { try { W.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { mem[k] = v; } }
  function notify(n, detail) { try { D.dispatchEvent(new CustomEvent(n, { detail: detail })); } catch (x) { } }
  var I = {
    search: '<circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/>',
    user: '<circle cx="12" cy="8.5" r="3.7"/><path d="M4.8 20c.7-3.7 3.6-5.6 7.2-5.6s6.5 1.9 7.2 5.6"/>',
    heart: '<path d="M12 20.2S3.8 15 3.8 9.3A4.4 4.4 0 0 1 12 7.2a4.4 4.4 0 0 1 8.2 2.1C20.2 15 12 20.2 12 20.2z"/>',
    bag: '<path d="M5.5 8.5h13l-1 11.5h-11z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/>',
    menu: '<path d="M3.5 8h17M3.5 16h17"/>',
    close: '<path d="M5 5l14 14M19 5L5 19"/>',
    arrow: '<path d="M4 12h16M14 6l6 6-6 6"/>',
    left: '<path d="M15 5l-7 7 7 7"/>',
    right: '<path d="M9 5l7 7-7 7"/>',
    tick: '<path d="M4 12.5l5 5L20 6.5"/>',
    filter: '<path d="M4 7h16M7 12h10M10 17h4"/>',
    ig: '<rect x="4" y="4" width="16" height="16" rx="4.5"/><circle cx="12" cy="12" r="3.6"/><circle cx="16.8" cy="7.2" r=".6"/>',
    tt: '<path d="M14 4v10.2a3.6 3.6 0 1 1-3.6-3.6M14 4c.3 2.4 1.9 4 4.4 4.2"/>',
    fb: '<path d="M13.5 20v-7h2.4l.4-2.8h-2.8V8.5c0-.8.3-1.4 1.5-1.4h1.4V4.6c-.5-.1-1.3-.2-2.2-.2-2.1 0-3.6 1.3-3.6 3.6v2.2H8.3V13h2.4v7z"/>',
    pin: '<circle cx="12" cy="12" r="8.2"/><path d="M10.8 17l1.5-6.6M9.8 11.6c-.5-1.9.8-3.4 2.5-3.4 1.6 0 2.6 1.1 2.4 2.7-.2 1.6-1.1 2.8-2.3 2.8-.6 0-1-.4-1.2-.9"/>',
    chev: '<path d="M6 9l6 6 6-6"/>',
    star: '<path d="M12 2.8l2.7 6 6.5.6-4.9 4.3 1.5 6.4L12 16.8 6.2 20.1l1.5-6.4L2.8 9.4l6.5-.6z"/>',
    play: '<path d="M8 5.5l11 6.5-11 6.5z"/>',
    pause: '<path d="M9 6v12M15 6v12"/>'
  };
  function svg(n, cls) { return '<svg viewBox="0 0 24 24" aria-hidden="true"' + (cls ? ' class="' + cls + '"' : '') + '>' + (I[n] || '') + '</svg>'; }
  function imgUrl(src, w) {
    if (!src) return '';
    if (!w || src.indexOf('cdn.shopify.com') < 0) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var RC = W.RC = W.RC || {};
  RC.fmt = fmt; RC.esc = esc; RC.svg = svg; RC.sget = sget; RC.sset = sset; RC.img = imgUrl;
  RC.giftBoxVariant = CFG.giftBoxVariant || null;

  /* ---------- product data (all active products, from collection.rcdata) ---------- */
  var productsP = null;
  RC.products = function () {
    if (productsP) return productsP;
    var base = (ROUTES.all || '/collections/all') + '?view=rcdata';
    productsP = fetch(base, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (first) {
      var pages = first.pages || 1, out = first.products || [];
      if (pages < 2) return out;
      var more = [];
      for (var i = 2; i <= pages; i++) more.push(fetch(base + '&page=' + i, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) { return d.products || []; }));
      return Promise.all(more).then(function (rest) { rest.forEach(function (x) { out = out.concat(x); }); return out; });
    }).catch(function () { productsP = null; return []; });
    return productsP;
  };

  /* ---------- header ---------- */
  var header = $('.site-header');
  var megaScrim = $('#mega-scrim');
  var panelBtns = $$('.nav [data-panel]');
  function closeSearch() {
    var sp = $('#searchp'), t = $('#search-t'); if (!sp) return;
    sp.classList.remove('open'); if (t) t.setAttribute('aria-expanded', 'false');
    if (!$('.mega.open') && header) header.classList.remove('is-open');
    if (!$('.mega.open') && megaScrim) megaScrim.classList.remove('open');
  }
  function closePanels() {
    panelBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); var p = $('#' + b.getAttribute('data-panel')); if (p) p.classList.remove('open'); });
    if (megaScrim) megaScrim.classList.remove('open');
    if (header) header.classList.remove('is-open');
    var sp = $('#searchp'); if (sp && sp.classList.contains('open')) closeSearch();
  }
  function openPanel(b) {
    closeSearch();
    panelBtns.forEach(function (x) { var on = x === b; x.setAttribute('aria-expanded', on ? 'true' : 'false'); var p = $('#' + x.getAttribute('data-panel')); if (p) p.classList.toggle('open', on); });
    if (megaScrim) megaScrim.classList.add('open');
    if (header) header.classList.add('is-open');
  }
  function hoverable() { return W.matchMedia && W.matchMedia('(hover:hover)').matches; }
  panelBtns.forEach(function (b) {
    b.addEventListener('mouseenter', function () { if (hoverable()) openPanel(b); });
    b.addEventListener('click', function () { b.getAttribute('aria-expanded') === 'true' ? closePanels() : openPanel(b); });
  });
  if (header) header.addEventListener('mouseleave', function () { if (hoverable() && !$('#searchp.open')) closePanels(); });
  if (megaScrim) megaScrim.addEventListener('click', closePanels);

  /* transparent header over the home hero */
  if (header && header.getAttribute('data-variant') === 'transparent') {
    var hero = $('.hero');
    var onScroll = function () { var lim = hero ? hero.offsetHeight - 140 : 40; header.classList.toggle('is-solid', W.scrollY > lim); };
    W.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* search overlay with Shopify predictive search */
  var st = $('#search-t');
  if (st) {
    st.addEventListener('click', function () {
      var sp = $('#searchp');
      if (sp.classList.contains('open')) { closeSearch(); return; }
      panelBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); var p = $('#' + b.getAttribute('data-panel')); if (p) p.classList.remove('open'); });
      sp.classList.add('open'); st.setAttribute('aria-expanded', 'true'); if (header) header.classList.add('is-open'); if (megaScrim) megaScrim.classList.add('open');
      setTimeout(function () { var i = $('#search-i'); if (i) i.focus(); }, 50);
    });
    var sx = $('#search-x'); if (sx) sx.addEventListener('click', closeSearch);
    var si = $('#search-i'), sr = $('#search-r'), timer = null, seq = 0;
    if (si && sr) si.addEventListener('input', function () {
      var q = si.value.trim();
      clearTimeout(timer);
      if (!q) { sr.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var my = ++seq;
        var url = (ROUTES.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url).then(function (r) { return r.json(); }).then(function (d) {
          if (my !== seq) return;
          var hits = ((d.resources || {}).results || {}).products || [];
          hits = hits.filter(function (p) { return p.type !== 'Gift box'; });
          sr.innerHTML = hits.length ? hits.map(function (p) {
            var cents = Math.round(parseFloat(p.price || '0') * 100);
            return '<a href="' + esc(p.url.split('?')[0]) + '"><img src="' + esc(imgUrl(p.image || (p.featured_image || {}).url, 200)) + '" alt="" loading="lazy"><span class="n">' + esc(p.title) + '</span>' + fmt(cents) + '</a>';
          }).join('') : '<p style="grid-column:1/-1;color:var(--ink-soft)">No pieces found. Try earrings, rings or a colour.</p>';
        }).catch(function () { });
      }, 160);
    });
  }

  /* ---------- drawers ---------- */
  var scrim = $('#scrim'), lastFocus = null, openDrawerEl = null;
  function openDrawer(el, trigger) {
    if (!el) return;
    closePanels();
    if (openDrawerEl && openDrawerEl !== el) closeDrawer();
    lastFocus = trigger || D.activeElement; openDrawerEl = el;
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false'); if (scrim) scrim.classList.add('open');
    D.body.style.overflow = 'hidden';
    var f = $('[data-close]', el) || $('button, a', el); if (f) setTimeout(function () { f.focus(); }, 60);
    if (trigger && trigger.setAttribute) trigger.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!openDrawerEl) return;
    openDrawerEl.classList.remove('open'); openDrawerEl.setAttribute('aria-hidden', 'true'); if (scrim) scrim.classList.remove('open');
    D.body.style.overflow = '';
    $$('[aria-controls="' + openDrawerEl.id + '"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    openDrawerEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  RC.openDrawer = openDrawer; RC.closeDrawer = closeDrawer;
  if (scrim) scrim.addEventListener('click', closeDrawer);
  D.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-close]');
    if (c) { var d = c.closest('.drawer'); if (d && d === openDrawerEl) closeDrawer(); }
  });
  D.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closePanels(); var dl = $('.dlg.open'); if (dl) { dl.classList.remove('open'); var s = $('.dlg-s'); if (s) s.classList.remove('open'); } }
    if (e.key === 'Tab' && openDrawerEl) {
      var f = $$('button, a[href], input, select, summary', openDrawerEl).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return; var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  var burger = $('.burger');
  if (burger) burger.addEventListener('click', function () { openDrawer($('#mnav'), burger); });

  /* ---------- wishlist (product handles in localStorage) ---------- */
  var WKEY = 'rc-wish';
  var wish = sget(WKEY, []);
  function wishPaint() {
    var c = $('#wish-count'); if (c) { c.textContent = wish.length; c.hidden = !wish.length; }
    $$('.wish[data-id]').forEach(function (b) { b.setAttribute('aria-pressed', wish.indexOf(b.getAttribute('data-id')) > -1 ? 'true' : 'false'); });
  }
  RC.wish = {
    list: function () { return wish.slice(); },
    has: function (h) { return wish.indexOf(h) > -1; },
    toggle: function (h) {
      var i = wish.indexOf(h); if (i > -1) wish.splice(i, 1); else wish.push(h);
      sset(WKEY, wish); wishPaint(); notify('rc:wish', { handle: h, on: i < 0 }); return i < 0;
    },
    paint: wishPaint
  };
  D.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('.wish[data-id]');
    if (w) { e.preventDefault(); RC.wish.toggle(w.getAttribute('data-id')); }
  });
  wishPaint();

  /* ---------- bag (Shopify cart) ---------- */
  var FREE = CFG.free || 100000;
  var cartState = null;
  function isGiftBox(item) { return item.product_type === 'Gift box' || item.handle === 'gift-box'; }
  function bagCount(cart) {
    var c = $('#bag-count'); if (!c) return;
    c.textContent = cart.item_count; c.hidden = !cart.item_count;
  }
  function renderBag(cart) {
    cartState = cart; bagCount(cart);
    var b = $('#bag-b'), f = $('#bag-f'); if (!b || !f) return;
    if (!cart.item_count) {
      b.innerHTML = '<div class="bag-empty"><p>Your bag is empty</p><a class="btn btn-ink" href="/collections/new-in">Shop new in</a></div>';
      f.innerHTML = ''; f.style.display = 'none'; return;
    }
    f.style.display = '';
    var st = cart.total_price, left = Math.max(0, FREE - st), pct = Math.min(100, st / FREE * 100);
    b.innerHTML = '<div class="ship"><span>' + (left > 0 ? 'You are <b>' + fmt(left) + '</b> away from free delivery' : 'Your order qualifies for free delivery') + '</span><div class="bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '" aria-label="Progress to free delivery"><i style="width:' + pct + '%"></i></div></div>' +
      cart.items.map(function (it, i) {
        var gift = isGiftBox(it), forName = it.properties && (it.properties.For || it.properties.for);
        var name = gift ? 'Gift box' + (forName ? ' for ' + forName : '') : it.product_title;
        var meta = gift ? 'Gift box' : '18k gold' + (it.variant_title && it.variant_title !== 'Default Title' ? ', ' + it.variant_title : '');
        var im = it.featured_image && it.featured_image.url ? imgUrl(it.featured_image.url, 200) : (it.image ? imgUrl(it.image, 200) : '');
        return '<div class="bag-item">' + (im ? '<img src="' + esc(im) + '" alt="' + esc(it.product_title) + '">' : '<span></span>') + '<div><div class="nm">' + (gift ? esc(name) : '<a href="' + esc(it.url) + '">' + esc(name) + '</a>') + '</div><div class="mt">' + esc(meta) + '</div>' +
          '<div class="rw"><div class="qty" role="group" aria-label="Quantity"><button type="button" data-q="-1" data-l="' + (i + 1) + '" data-n="' + it.quantity + '" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-q="1" data-l="' + (i + 1) + '" data-n="' + it.quantity + '" aria-label="Increase quantity">+</button></div><span class="price">' + fmt(it.final_line_price) + '</span></div>' +
          '<button class="rm" type="button" data-rm="' + (i + 1) + '" style="margin-top:10px">Remove</button></div></div>';
      }).join('');
    f.innerHTML = '<div class="row"><span>Subtotal</span><span class="serif" style="font-size:30px">' + fmt(cart.total_price) + '</span></div><p style="font-size:13px;color:var(--ink-soft);margin-bottom:16px">' + esc(CFG.bagNote || 'Delivery across South Africa. Pay in 4 with Payflex at checkout.') + '</p>' +
      '<form action="' + (ROUTES.cart || '/cart') + '" method="post"><button class="btn btn-ink" type="submit" name="checkout" style="width:100%">Checkout</button></form>' +
      '<div style="display:flex;justify-content:center;gap:22px;margin-top:18px"><a class="link-line" href="' + (ROUTES.cart || '/cart') + '">View bag</a><button class="link-line" type="button" data-close>Continue shopping</button></div>';
  }
  function cartFetch(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: body ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) { var err = new Error(d.description || d.message || 'Could not update the bag'); err.data = d; throw err; } return d; }); });
  }
  RC.cart = {
    get: function () { return cartState; },
    refresh: function () {
      return cartFetch((ROUTES.cart || '/cart') + '.js').then(function (c) { renderBag(c); notify('rc:cart', c); return c; });
    },
    add: function (items, opts) {
      /* the cart lists the newest line first, so send gift boxes first and they sit under their piece */
      var gv = String(RC.giftBoxVariant || '');
      items = (items || []).slice().sort(function (a, b) { return (String(b.id) === gv) - (String(a.id) === gv); });
      return cartFetch((ROUTES.cartAdd || '/cart/add') + '.js', { items: items }).then(function () {
        return RC.cart.refresh();
      }).then(function (c) { if (!opts || opts.open !== false) openDrawer($('#bag'), $('#bag-t')); return c; });
    },
    change: function (line, quantity) {
      return cartFetch((ROUTES.cartChange || '/cart/change') + '.js', { line: line, quantity: quantity }).then(function (c) { renderBag(c); notify('rc:cart', c); return c; });
    },
    open: function () { return RC.cart.refresh().then(function (c) { openDrawer($('#bag'), $('#bag-t')); return c; }); }
  };
  var bagEl = $('#bag');
  if (bagEl) bagEl.addEventListener('click', function (e) {
    var q = e.target.closest('[data-q]'), r = e.target.closest('[data-rm]');
    if (q) RC.cart.change(+q.getAttribute('data-l'), Math.max(0, +q.getAttribute('data-n') + +q.getAttribute('data-q'))).catch(function () { });
    if (r) RC.cart.change(+r.getAttribute('data-rm'), 0).catch(function () { });
  });
  var bagT = $('#bag-t');
  if (bagT) bagT.addEventListener('click', function () { RC.cart.open(); });
  RC.cart.refresh().catch(function () { });

  /* ---------- reveal on enter ---------- */
  function initReveal() {
    var els = $$('.reveal:not(.in)');
    var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in W)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }
  RC.initReveal = initReveal;

  /* ---------- rails ---------- */
  function railControls(rail, prev, next) {
    if (!rail || rail.__rc) return; rail.__rc = 1;
    function step() { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 24 : 300; }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  }
  RC.railControls = railControls;
  function initRails(root) {
    $$('[data-rail]', root).forEach(function (rail) {
      var host = rail.closest('[data-rail-host]') || rail.closest('section') || D;
      var btns = $$('.rail-ctl button', host);
      railControls(rail, btns[0], btns[1]);
    });
  }
  RC.initRails = initRails;

  /* ---------- home film play/pause ---------- */
  function initFilm(root) {
    $$('[data-film]', root).forEach(function (sec) {
      var fv = $('video', sec), fp = $('.film-p', sec);
      if (!fv || !fp || fp.__rc) return; fp.__rc = 1;
      function paint(paused) {
        fp.setAttribute('aria-pressed', paused ? 'true' : 'false'); fp.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        fp.innerHTML = paused ? svg('play') : svg('pause');
      }
      var still = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* the film loads only when it comes near the screen, so it does not slow the first paint */
      function load() {
        if (fv.__loaded) return; fv.__loaded = 1;
        var src = fv.getAttribute('data-src'); if (src && !fv.getAttribute('src')) { fv.src = src; fv.preload = 'auto'; }
        if (!still) { var pr = fv.play(); if (pr && pr.catch) pr.catch(function () { }); }
      }
      if ('IntersectionObserver' in W) {
        var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { load(); io.disconnect(); } }); }, { rootMargin: '300px 0px' });
        io.observe(sec);
      } else load();
      if (still) paint(true);
      fp.addEventListener('click', function () {
        if (fv.paused) { load(); var pr = fv.play(); if (pr && pr.catch) pr.catch(function () { }); paint(false); } else { fv.pause(); paint(true); }
      });
    });
  }
  RC.initFilm = initFilm;

  function initAll(root) { initRails(root); initFilm(root); initReveal(); wishPaint(); }
  RC.initAll = initAll;
  initAll(D);
  /* theme editor: re-init a section when it reloads */
  D.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* ---------- cookie banner (Shopify Customer Privacy API) ---------- */
  var CKEY = 'rc-cookie-consent';
  var privacy = null;
  function ckGet() { try { var v = W.localStorage.getItem(CKEY); return v ? JSON.parse(v) : null; } catch (e) { return W.__rcConsent || null; } }
  function ckPut(v) { W.__rcConsent = v; try { W.localStorage.setItem(CKEY, JSON.stringify(v)); } catch (e) { } }
  function applyConsent(an, mk) {
    if (privacy && privacy.setTrackingConsent) {
      try { privacy.setTrackingConsent({ analytics: !!an, marketing: !!mk, preferences: !!an, sale_of_data: !!mk }, function () { }); } catch (e) { }
    }
    if (W.gtag) {
      W.gtag('consent', 'update', { analytics_storage: an ? 'granted' : 'denied', ad_storage: mk ? 'granted' : 'denied', ad_user_data: mk ? 'granted' : 'denied', ad_personalization: mk ? 'granted' : 'denied' });
      W.dataLayer.push({ event: 'consent_update', consent_analytics: !!an, consent_marketing: !!mk });
    }
  }
  var ckCss = '.ck{position:fixed;z-index:95;left:max(16px,env(safe-area-inset-left,0px));bottom:calc(16px + env(safe-area-inset-bottom,0px));width:min(440px,calc(100vw - 32px));background:#FFFCF6;color:#2A2520;border:1px solid #E2D6C0;border-radius:6px;box-shadow:0 18px 50px rgba(42,37,32,.18);padding:16px 18px 14px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;font-size:14px;line-height:1.55;transform:translateY(0);opacity:1;transition:transform .45s cubic-bezier(.22,.61,.36,1),opacity .45s}' +
    '.ck[hidden]{display:none}.ck.ck-out{transform:translateY(16px);opacity:0}' +
    '.ck h2{font-family:"Cormorant Garamond",Georgia,serif;font-style:italic;font-weight:500;font-size:24px;line-height:1.1;margin:0 0 6px}' +
    '.ck p{margin:0;color:#5C5347}.ck p a{color:#7A5C2B;text-decoration:underline;text-underline-offset:3px}' +
    '.ck-row{display:flex;flex-wrap:wrap;gap:8px;margin-top:12px;align-items:center}' +
    '.ck-b{display:inline-flex;align-items:center;justify-content:center;min-height:40px;padding:0 18px;border-radius:999px;border:1px solid #2A2520;font:inherit;font-size:13.5px;cursor:pointer;background:none;color:#2A2520;transition:background .2s,color .2s}' +
    '.ck-b.ink{background:#2A2520;color:#FAF6EF}.ck-b.ink:hover{background:#7A5C2B;border-color:#7A5C2B}.ck-b:not(.ink):hover{background:#2A2520;color:#FAF6EF}' +
    '.ck-l{background:none;border:0;padding:6px 2px;font:inherit;font-size:13.5px;color:#2A2520;text-decoration:underline;text-underline-offset:3px;cursor:pointer;margin-left:auto}' +
    '.ck :focus-visible{outline:2px solid #7A5C2B;outline-offset:3px}.ck-set{margin-top:10px}.ck-set[hidden]{display:none}' +
    '.ck-opt{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding:9px 0}.ck-opt b{display:block;font-weight:600;font-size:14px;color:#2A2520}.ck-opt span{display:block;font-size:12.5px;color:#5C5347}' +
    '.ck-sw{position:relative;flex:none;width:44px;height:26px;margin-top:2px}.ck-sw input{position:absolute;inset:0;opacity:0;margin:0;cursor:pointer;z-index:1}' +
    '.ck-sw i{position:absolute;inset:0;border-radius:99px;background:#D8C6A8;transition:background .2s}' +
    '.ck-sw i::after{content:"";position:absolute;top:3px;left:3px;width:20px;height:20px;border-radius:50%;background:#FFFCF6;box-shadow:0 1px 2px rgba(42,37,32,.25);transition:transform .2s}' +
    '.ck-sw input:checked+i{background:#2A2520}.ck-sw input:checked+i::after{transform:translateX(18px)}.ck-sw input:disabled+i{background:#B08D57;opacity:.75}.ck-sw input:disabled{cursor:not-allowed}.ck-sw input:focus-visible+i{outline:2px solid #7A5C2B;outline-offset:3px}' +
    '@media (max-width:560px){.ck{left:0;right:0;bottom:0;width:auto;border-radius:6px 6px 0 0;border-left:0;border-right:0;padding:18px max(16px,env(safe-area-inset-left,0px)) calc(16px + env(safe-area-inset-bottom,0px)) max(16px,env(safe-area-inset-right,0px))}.ck-row .ck-b{flex:1 1 auto}.ck-l{margin-left:0}}' +
    '@media (prefers-reduced-motion:reduce){.ck{transition:none}}';
  function ckMainRow() { return '<button class="ck-b ink" type="button" data-ck="all">Accept all</button><button class="ck-b" type="button" data-ck="necessary">Necessary only</button><button class="ck-l" type="button" data-ck="settings" aria-expanded="false" aria-controls="ck-set">Settings</button>'; }
  function ckBuild() {
    var ex = D.getElementById('rc-cookie'); if (ex) return ex;
    var stl = D.createElement('style'); stl.textContent = ckCss; D.head.appendChild(stl);
    var el = D.createElement('section');
    el.className = 'ck'; el.id = 'rc-cookie'; el.hidden = true;
    el.setAttribute('role', 'region'); el.setAttribute('aria-labelledby', 'ck-h');
    el.innerHTML = '<h2 id="ck-h">Cookies on Raine &amp; Co</h2>' +
      '<p>We use necessary cookies to run the shop. With your permission we also use analytics and marketing cookies to improve the website and show you relevant adverts. <a href="' + esc(CFG.cookiePolicy || '/pages/cookie-policy') + '">Cookie policy</a></p>' +
      '<div class="ck-set" id="ck-set" hidden>' +
      '<div class="ck-opt"><div><b>Strictly necessary</b><span>Bag, checkout, sign-in and security.</span></div><label class="ck-sw"><input type="checkbox" checked disabled aria-label="Strictly necessary cookies, always on"><i></i></label></div>' +
      '<div class="ck-opt"><div><b>Analytics</b><span>Which pages are visited, so we can improve them.</span></div><label class="ck-sw"><input type="checkbox" id="ck-an" aria-label="Analytics cookies"><i></i></label></div>' +
      '<div class="ck-opt"><div><b>Marketing</b><span>Relevant adverts on social media and search.</span></div><label class="ck-sw"><input type="checkbox" id="ck-mk" aria-label="Marketing cookies"><i></i></label></div>' +
      '</div><div class="ck-row" id="ck-main">' + ckMainRow() + '</div>';
    D.body.appendChild(el);
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ck]'); if (!b) return;
      var a = b.getAttribute('data-ck');
      if (a === 'all') ckSave(true, true);
      else if (a === 'necessary') ckSave(false, false);
      else if (a === 'save') ckSave(D.getElementById('ck-an').checked, D.getElementById('ck-mk').checked);
      else if (a === 'settings') ckSettings(true);
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !D.getElementById('ck-set').hidden) ckSettings(false); });
    return el;
  }
  function ckSettings(on) {
    var set = D.getElementById('ck-set'), row = D.getElementById('ck-main'), c = ckGet();
    set.hidden = !on;
    D.getElementById('ck-an').checked = !!(c && c.analytics);
    D.getElementById('ck-mk').checked = !!(c && c.marketing);
    row.innerHTML = on ? '<button class="ck-b ink" type="button" data-ck="save">Save choices</button><button class="ck-b" type="button" data-ck="all">Accept all</button>' : ckMainRow();
    if (on) D.getElementById('ck-an').focus();
  }
  function ckSave(an, mk) {
    ckPut({ analytics: !!an, marketing: !!mk, at: new Date().toISOString().slice(0, 10) });
    applyConsent(an, mk);
    var el = D.getElementById('rc-cookie');
    el.classList.add('ck-out');
    setTimeout(function () { el.hidden = true; el.classList.remove('ck-out'); }, 420);
  }
  function ckOpen(withSettings) { var el = ckBuild(); el.hidden = false; ckSettings(!!withSettings); }
  W.RCCookie = RC.cookie = { open: ckOpen, get: ckGet };
  D.addEventListener('click', function (e) { var t = e.target.closest && e.target.closest('[data-cookie-settings]'); if (t) { e.preventDefault(); ckOpen(true); } });
  function ckInit() {
    var saved = ckGet();
    if (!saved) { if (!D.body.getAttribute('data-no-cookie')) ckBuild().hidden = false; }
    if (W.Shopify && W.Shopify.loadFeatures) {
      W.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) return;
        privacy = W.Shopify.customerPrivacy;
        var s = ckGet(); if (s) applyConsent(s.analytics, s.marketing);
      });
    }
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', ckInit); else ckInit();
})();

/* ---------- analytics events for Google Tag Manager (ecommerce events come from the Google & YouTube app) ---------- */
(function () {
  var W = window, D = document;
  function dl(o) { W.dataLayer = W.dataLayer || []; W.dataLayer.push(o); }
  var q = W.location.search;
  if (/[?&]customer_posted=true/.test(q)) dl({ event: 'sign_up', method: 'newsletter' });
  if (/[?&]contact_posted=true/.test(q)) {
    var form = (D.body.className.match(/template-page-([a-z-]+)/) || [])[1] || 'contact';
    dl({ event: 'generate_lead', form_name: form });
  }
  D.addEventListener('rc:wish', function (e) {
    var d = e.detail || {};
    if (d.on) dl({ event: 'add_to_wishlist', item_id: d.handle });
  });
  var gv = function () { return String((W.RC && W.RC.giftBoxVariant) || ''); };
  if (W.RC && W.RC.cart && W.RC.cart.add) {
    var add = W.RC.cart.add;
    W.RC.cart.add = function (items, opts) {
      var g = gv();
      (items || []).forEach(function (it) { if (g && String(it.id) === g) dl({ event: 'add_gift_box', item_name: (it.properties && it.properties.For) || '' }); });
      return add.apply(this, arguments);
    };
  }
  function listName() {
    var h = D.querySelector('main h1');
    var p = D.body.getAttribute('data-page') || '';
    return (h ? h.textContent.trim() : p).slice(0, 80) || p;
  }
  function itemOf(c, i) {
    return { item_id: 'shopify_ZA_' + c.getAttribute('data-pid') + '_' + c.getAttribute('data-vid'), item_name: c.getAttribute('data-name'), item_brand: 'Raine & Co', item_category: c.getAttribute('data-type'), price: parseFloat(c.getAttribute('data-price')) || 0, index: i, item_list_name: listName() };
  }
  /* select_item: a product card is clicked (the Google & YouTube app does not send this one) */
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.card a[href*="/products/"]');
    if (!a) return;
    var c = a.closest('.card'); if (!c || !c.getAttribute('data-pid')) return;
    var all = Array.prototype.slice.call(D.querySelectorAll('.card[data-pid]'));
    dl({ ecommerce: null });
    dl({ event: 'select_item', ecommerce: { item_list_name: listName(), items: [itemOf(c, all.indexOf(c))] } });
  }, true);
  /* view_cart for the bag drawer (the app only sends view_cart on the /cart page) */
  var bag = D.getElementById('bag');
  if (bag && W.MutationObserver && !/^\/cart\/?$/.test(W.location.pathname)) {
    var wasOpen = bag.classList.contains('open');
    function sendViewCart(c) {
      if (!c || !c.items || !c.items.length) return;
      dl({ ecommerce: null });
      dl({ event: 'view_cart', cart_location: 'drawer', ecommerce: { currency: c.currency || 'ZAR', value: c.total_price / 100, items: c.items.map(function (it, i) { return { item_id: 'shopify_ZA_' + it.product_id + '_' + it.variant_id, item_name: it.product_title, item_brand: 'Raine & Co', item_category: it.product_type, item_variant: it.variant_title || undefined, price: it.final_price / 100, quantity: it.quantity, index: i }; }) } });
    }
    new MutationObserver(function () {
      var open = bag.classList.contains('open');
      if (open && !wasOpen) {
        var c = W.RC && W.RC.cart && W.RC.cart.get();
        if (c) sendViewCart(c); else fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(sendViewCart).catch(function () { });
      }
      wasOpen = open;
    }).observe(bag, { attributes: true, attributeFilter: ['class'] });
  }
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a, button');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('mailto:') === 0) { dl({ event: 'email_click', link_url: href.slice(7) }); return; }
    var t = (a.textContent || '').toLowerCase();
    if (/size-guide|size guide|length-guide|length guide/.test(href + ' ' + t)) dl({ event: 'view_size_guide', link_text: (a.textContent || '').trim().slice(0, 60) });
  }, true);
})();
